import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertClientContactPayload, UpsertClientContactInput, UpsertAddressInput, UpsertEmailInput, UpsertPhoneInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_CLIENT_CONTACT = gql`
    mutation upsertClientContact($input: UpsertClientContactInput!){
        upsertClientContact(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpsertClientContact = async (
    client: ApolloClient<NormalizedCacheObject>,
    options: {
        clientId: string,
        addresses?: UpsertAddressInput[],
        description?: string,
        emails?: UpsertEmailInput[],
        id?: string,
        isActive?: boolean,
        isPrimary?: boolean,
        jobTitle?: string,
        name?: string,
        phones?: UpsertPhoneInput[]
    }
): Promise<UpsertClientContactPayload | undefined> => {
    const {
        clientId,
        addresses,
        description,
        emails,
        id,
        isActive,
        isPrimary,
        jobTitle,
        name,
        phones
    } = options as UpsertClientContactInput;
    const { data, errors } = await client.mutate<{ upsertClientContact: UpsertClientContactPayload }>({
        variables: {
            input: {
                clientId,
                addresses,
                description,
                emails,
                id,
                isActive,
                isPrimary,
                jobTitle,
                name,
                phones
            }
        },
        mutation: MUTATION_UPSERT_CLIENT_CONTACT
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the client contact save.');
    }
    if (data && data.upsertClientContact) {
        return data.upsertClientContact;
    }
    return undefined;
};